import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { JwtInterceptor, ErrorInterceptor } from './core/interceptors';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GameComponent } from './game/game.component';
import { ThemeModule } from './@theme/theme.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgtUniversalModule } from '@ng-toolkit/universal';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard, NoAuthGuard } from './core/guards/auth.guard';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { DeviceDetectorModule } from 'ngx-device-detector';


import {
  HeaderComponent,
  FooterComponent
} from './@theme';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    AppComponent,
    GameComponent,
    HeaderComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ThemeModule,
    HttpClientModule,
    NgtUniversalModule,
    ToastrModule.forRoot(),
    MalihuScrollbarModule.forRoot(),
    DeviceDetectorModule.forRoot()
  ],
  providers: [
    AuthGuard,
    NoAuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
